import {
    ContentSectionContainer,
    EEditorType,
    FullBar,
    GenericWrapperContext,
    Header
} from "@cakemail-org/ui-components-v2"
import { TFileManager } from "./types"
import { ImagesContext } from "./context"
import BeeEditor from "../../components/beeEditor"
import { useTranslation } from "react-i18next"
import { useContext } from "react"
import "./styles.scss"


export default function FileManager({ }: TFileManager) {

    const { t } = useTranslation()
    const genericWrapper = useContext(GenericWrapperContext)
    return <ContentSectionContainer className="imagesContainer">
        <ImagesContext.Provider value={{}}>
            <FullBar
                left={<Header
                    heading={t("file-manager-title")}
                    headingVariant="titleL"
                    support={genericWrapper.account?.name}
                    headingTooltip={t("file-manager-tooltip")}
                />}
            />
            <BeeEditor
                className="beeEditorModal beeFileManager"
                variant="inline"
                editorType={EEditorType.fileManager}
            />
        </ImagesContext.Provider>
    </ContentSectionContainer>
}